import { openChangeTokenModal } from '@/redux/slices/ui-slice';
import { selectActivePermission, selectActiveTokens } from '@/redux/slices/user-slice';
import { CommonTokenScopes } from '@marpla/api-sdk';
import InfoBox from '@marpla/ui/components/InfoBox';
import Typography from '@marpla/ui/components/Typography';
import Box from '@mui/material/Box';
import { type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Инфоблок с предупреждениями об отсутствии API токенов (базового и сервисного)
export const IntegrationTokenInfo: FC = () => {
  const dispatch = useDispatch();

  const permission = useSelector(selectActivePermission);

  const { hasToken, hasServiceToken } = useSelector(selectActiveTokens);

  if (!permission) return null;

  const handleOpenApiKeyModal = (): void => {
    dispatch(
      openChangeTokenModal({
        mode: 'edit',
        requiredScopes: [CommonTokenScopes.PROMOTION, CommonTokenScopes.CONTENT, CommonTokenScopes.ANALYTICS],
      }),
    );
  };

  if (hasToken && hasServiceToken) return null;

  return (
    <Box mb={1}>
      {hasToken === false && (
        <InfoBox
          type="error"
          showCloseButton={false}
          text={
            <Typography variant="bodyRegular">
              Для работы в сервисе введите базовый токен в{' '}
              <span
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={handleOpenApiKeyModal}
              >
                настройках изменения API ключа
              </span>
            </Typography>
          }
        />
      )}
      {/* 
      {hasServiceToken === false && (
        <Box mt={1}>
          <InfoBox
            type="warning"
            showCloseButton={false}
            text={
              <Typography variant="bodyRegular">
                Для повышения скорости работы приложения, подключите сервисный токен{' '}
                <span
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={handleOpenApiKeyModal}
                >
                  настройки изменения API ключа
                </span>
              </Typography>
            }
          />
        </Box>
      )} */}
    </Box>
  );
};
